<div class="content">
  <div class="example-wrap">
    <form class="k-form k-form-md">
      <!-- Fixed Header -->
      <div class="k-form-header">
        <div class="k-form-buttons">
          <div class="title-section">
            @if (showServiceConfiguration()) {
              <button
                kendoButton
                [svgIcon]="arrowLeftIcon"
                (click)="goBackToServiceSelection(); $event.stopPropagation()"
                fillMode="flat"
                title="Back to Service Selection"
                class="back-button"
              ></button>
            }
            <h2 class="k-form-title">{{ slideoutTitle() }}</h2>
          </div>
          <button
            kendoButton
            [svgIcon]="xIcon"
            (click)="onCancel()"
            fillMode="flat"
            title="Close"
          ></button>
        </div>
      </div>

      <!-- Scrollable Content -->
      <div class="k-form-content">
        <!-- Service Selection Cards (shown when adding new service) -->
        @if (showServiceSelection()) {
          <div class="services-selection mb-4">
            <label class="form-label fw-bold mb-3">Select Service to Add</label>
            <div class="row g-3">
              @for (service of filteredServices(); track service.value) {
                <div class="col-md-6">
                  <div
                    class="service-card"
                    [class.selected]="isServiceSelected(service.value)"
                    (click)="selectService(service.value); $event.stopPropagation()"
                    role="button"
                    tabindex="0"
                    (keydown.enter)="selectService(service.value); $event.stopPropagation()"
                    (keydown.space)="selectService(service.value); $event.stopPropagation()"
                  >
                    <div class="service-card-header">
                      <div
                        class="service-icon"
                        [style.background-color]="getServiceIconBackground(service.value)"
                      >
                        <kendo-svg-icon
                          [icon]="service.icon"
                          size="large"
                        ></kendo-svg-icon>
                      </div>
                      <div class="service-checkbox">
                        <input
                          type="checkbox"
                          kendoCheckBox
                          [checked]="isServiceSelected(service.value)"
                          (change)="selectService(service.value); $event.stopPropagation()"
                        />
                      </div>
                    </div>
                    <div class="service-card-body">
                      <h6 class="service-title">{{ service.label }}</h6>
                      <p class="service-description">{{ getServiceDescription(service.value) }}</p>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }

        <!-- Service Configuration Components (shown when service is selected or modifying existing service) -->
        @if (showServiceConfiguration()) {
          <div class="service-configuration mb-4">
            @switch (selectedService() || internalSlideoutData()?.serviceType) {
              @case (ServiceType.MXDR) {
                <app-mxdr-service
                  [initialData]="serviceFormData()"
                  [isNarrowLayout]="true"
                  (dataUpdate)="onServiceFormDataUpdate($event)"
                  (validityUpdate)="onServiceFormValidityUpdate($event)"
                ></app-mxdr-service>
              }
              @case (ServiceType.MEDR) {
                <app-medr-service
                  [initialData]="serviceFormData()"
                  [isNarrowLayout]="true"
                  (dataUpdate)="onServiceFormDataUpdate($event)"
                  (validityUpdate)="onServiceFormValidityUpdate($event)"
                ></app-medr-service>
              }
              @case (ServiceType.VSS) {
                <app-mvss-service
                  [initialData]="serviceFormData()"
                  [isNarrowLayout]="true"
                  (dataUpdate)="onServiceFormDataUpdate($event)"
                  (validityUpdate)="onServiceFormValidityUpdate($event)"
                ></app-mvss-service>
              }
              @case (ServiceType.MES) {
                <app-mes-service
                  [initialData]="serviceFormData()"
                  [isNarrowLayout]="true"
                  (dataUpdate)="onServiceFormDataUpdate($event)"
                  (validityUpdate)="onServiceFormValidityUpdate($event)"
                ></app-mes-service>
              }
              @case (ServiceType.PROFESSIONAL_SERVICES) {
                <app-professional-services
                  [initialData]="serviceFormData()"
                  (dataUpdate)="onServiceFormDataUpdate($event)"
                  (validityUpdate)="onServiceFormValidityUpdate($event)"
                ></app-professional-services>
              }
            }
          </div>
        }
      </div>

      <!-- Fixed Footer -->
      <div class="k-form-footer">
        <div class="k-form-buttons">
          <button
            kendoButton
            themeColor="primary"
            [svgIcon]="saveIcon"
            [disabled]="!isFormValid()"
            (click)="onSave()"
          >
            Save Modification
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
